export default [
  { id: 'drugId', label: 'Drug ID' },
  { id: 'dateStarted', label: 'Date Started' },
  { id: 'onDemand', label: 'On Demand', type: 'boolean' },
  { id: 'pushNotice', label: 'Push Notice', type: 'boolean' },
];
